export function getSharePanelQrFilename(
	whiteboardName: string | null | undefined,
	suffix: string,
) {
	const normalizedName = whiteboardName
		?.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "");

	return normalizedName ? `${normalizedName}-${suffix}.svg` : `${suffix}.svg`;
}
